import React from 'react'
import 'stylesheets/TimerAppStyles/TodoList.css'

const TodoList = ({children}) => {
    return (
        <ul>
            {children}
        </ul>
    )
}

export { TodoList }